import { render, staticRenderFns } from "./section-highlight.vue?vue&type=template&id=47a23ca8&scoped=true"
import script from "./section-highlight.vue?vue&type=script&lang=js"
export * from "./section-highlight.vue?vue&type=script&lang=js"
import style0 from "./section-highlight.vue?vue&type=style&index=0&id=47a23ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a23ca8",
  null
  
)

export default component.exports